import { useEffect, useState } from "react";
import FlexBox, { FlexGrow } from "../../components/FlexBox"
import SnackBar from "../../components/SnackBar";
import GetPrefixModal from "../PillarDoc/GetPrefixModal";
import axios from "axios";
import styled from "styled-components";
import theme from "../../styles/theme";
import DownloadIcon from "@mui/icons-material/Download"; // Import the Download icon
import ProgressBar from "../../components/ProgressBar";
import { VersionSelectBlock } from "./VersionSelectBlock";
import { GenerateOptions } from "./GenerateOptions";

const CustomFlex = styled(FlexBox)`
  padding-top: 20px;
  align-items: center;
  //   border-bottom: 1px solid #f0f6fe;
`;
const Header = styled.h4`
  text-align: center;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0px;
  color: ${theme.color.darkBlueGray900};
`;

export const CurriculumDoc = () => {
    const [allUniversities, setAllUniversities] = useState<any>([]);

    const [tempData, setTempData] = useState({
        singlePillar: false,
        selectedPillar: "",
        differencesOnly: false,
        outputFormat: "html"
    })
    const [docStatus, setDocStatus] = useState<{
        percent_complete: number;
        status: string;
        success: boolean;
    }>({ percent_complete: 0, status: "", success: false });

    const [generateState, setGenerateState] = useState("");
    const [downloadURL, setDownloadURL] = useState<string | null>(null);
    const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null); // State to track interval ID
    const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
    const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [isGenerateClicked, setIsGenerateClicked] = useState<boolean>(false); // Track if Generate button was clicked
    const [getPrefixOpen, setGetPrefixOpen] = useState<boolean>(false);
    const [firstVersion, setFirstVersion] = useState({
        university: null,
        program: null,
        version: null,
    });

    const [secondVersion, setSecondVersion] = useState({
        university: null,
        program: null,
        version: null,
    });

    const [compareVersions, setCompareVersions] = useState(false);
    const [differencesOnly, setDifferencesOnly] = useState(false);



    type PillarCustomType = {
        label: string;
        value: string;
        selected: boolean;
        index: string;
        graphics: any;
        subdomains: Array<any>;
    };

    const fetchUniversities = () => {
        axios
            .get("/university")
            .then((res) => {
                const universities = res.data.universities.map((uni: any) => ({
                    value: uni.short_name,
                    label: uni.name,
                    programs: uni.program || [], // Include programs array
                }));
                setAllUniversities(universities);
            })
            .catch(function (error) {
                console.error("Error fetching universities:", error);
                setIsErrorOpen(true);
                setMessage("Failed to fetch universities");
            });
    };

    useEffect(() => {
        if (allUniversities.length === 0) {
            fetchUniversities();
        }
    }, []);

    const DownloadDoc = () => {
        setGenerateState("");
        if (downloadURL) {
            // Open the download URL in a new tab
            window.open(process.env.REACT_APP_DOC_URL + "." + downloadURL, "_blank");
        } else {
            setIsErrorOpen(true);
            setMessage("Download URL is not available.");
        }
    };
    const handleGenerate = (singlePillar: boolean,
        selectedPillar: string,
        differencesOnly: boolean,
        outputFormat: string) => {
        setTempData({
            singlePillar: singlePillar,
            selectedPillar: selectedPillar,
            differencesOnly: differencesOnly,
            outputFormat: outputFormat
        })
        setGetPrefixOpen(true)
    }

    const generateDoc = (doc_name: string) => {
        setDocStatus({ percent_complete: 0, status: "", success: false });
        setIsGenerateClicked(true); // Disable the Generate button after clicking
        setGenerateState("loading");
        const transformSelectedChild = () => {
            const universities = [];

            // if compare version is not selectedd, only first condition will satisfy
            if (firstVersion.university && firstVersion.program && firstVersion.version) {
                universities.push({
                    university_code: (firstVersion.university as any).value,
                    program_name: (firstVersion.program as any).value,
                    version_number: (firstVersion.version as any).value,
                });
            }

            if (secondVersion.university && secondVersion.program && secondVersion.version) {
                universities.push({
                    university_code: (secondVersion.university as any).value,
                    program_name: (secondVersion.program as any).value,
                    version_number: (secondVersion.version as any).value,
                });
            }
            const modified = {
                universities: universities,
                format: tempData?.outputFormat,
                doc_name: doc_name,
                pillar_prefix: tempData.singlePillar ? tempData.selectedPillar : "",
                diffs_only: tempData.differencesOnly,
            };

            return modified;
        };

        const transformedData = transformSelectedChild();
        axios
            .post("/document/generate", transformedData)
            .then((res) => {
                if (
                    res?.data?.message === "Document generation completed successfully"
                ) {
                    setDownloadURL(res.data.download_url); // Set the download link
                    setDocStatus({ percent_complete: 100, status: "", success: true });
                    setIsGenerateClicked(false); // Re-enable the Generate button after success
                    setGenerateState("success");
                } else {
                    setGenerateState("");
                }
            })
            .catch((err: any) => {
                setIsErrorOpen(true);
                setMessage(err?.response?.data?.error || "Error generating document");
                setIsGenerateClicked(false); // Re-enable the Generate button on error
                setGenerateState("");
            });
    };

    return (
        <FlexGrow
            style={{
                background: "white",
                overflow: "auto",
                minHeight: "calc(100vh - 10px)",
                color: "black",
            }}
        >
            <SnackBar
                isOpen={isErrorOpen}
                setOpen={setIsErrorOpen}
                header="Error!"
                message={message}
                type="error"
            /> <GetPrefixModal
                isOpen={getPrefixOpen}
                setOpen={setGetPrefixOpen}
                title=""
                description="Enter the prefix for the document"
                confirmFunction={(prefix: string) => {
                    generateDoc(prefix);
                    setGetPrefixOpen(false);
                }}
            />{generateState && (
                <div
                    style={{
                        position: "fixed",
                        display: "flex",
                        alignItems: "center",
                        top: 20,
                        right: 40,
                        background: "#eff6ff",
                        padding: 10,
                        borderRadius: 10,
                        fontSize: 10,
                        boxShadow: "0 2px 5px #808080cc",
                        border: "1px solid rgb(219, 234, 254)",
                    }}
                >
                    <div>
                        {generateState === "success" ? "Ready to Download" : "Generating"}
                        {generateState === "loading" && (
                            <ProgressBar value={docStatus.percent_complete} />
                        )}
                    </div>
                    {generateState === "success" && (
                        <DownloadIcon
                            onClick={DownloadDoc}
                            fontSize="large"
                            style={{ marginLeft: 10, color: "green", cursor: "pointer" }}
                        />
                    )}
                </div>
            )}<CustomFlex>
                <FlexGrow>
                    <Header>Generate Curriculum Documentation</Header>
                </FlexGrow>

            </CustomFlex>

            <VersionSelectBlock
                universities={allUniversities}
                setIsErrorOpen={setIsErrorOpen}
                setErrorMessage={setMessage}
                firstVersion={firstVersion}
                setFirstVersion={setFirstVersion}
                secondVersion={secondVersion}
                setSecondVersion={setSecondVersion}
                compareVersions={compareVersions}
                setCompareVersions={setCompareVersions}
                setDifferencesOnly={setDifferencesOnly}
            />
            <GenerateOptions
                handleGenerate={handleGenerate}
                firstVersion={firstVersion}
                secondVersion={secondVersion}
                compareVersions={compareVersions}
                differencesOnly={differencesOnly} setDifferencesOnly={setDifferencesOnly}
            />
        </FlexGrow>
    )
}